import { User } from "@/modules/users/interfaces/user";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useRoleUsersStore = defineStore("roleUsers", () => {
  const roleUsers = ref<User[]>([]);
  const roleId = ref<number>();

  return {
    roleUsers,
    roleId,

    setRoleUsers(value: User[]) {
      roleUsers.value = value;
    },
    setRoleId(value: number) {
      roleId.value = value;
    },
  };
});
